export default __webpack_public_path__ + "static/media/FLOTA_MARINA_BANNER_RIGHT_IMAGE.63e3f1b3.png";